import { render } from "./HSButton.vue?vue&type=template&id=04fd7f7e&scoped=true"
import script from "./HSButton.vue?vue&type=script&lang=js"
export * from "./HSButton.vue?vue&type=script&lang=js"

import "./HSButton.vue?vue&type=style&index=0&id=04fd7f7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fd7f7e"]])

export default __exports__